import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const createBooking = (data) => api.post("/bookings", data).then((r) => r.data);
export const createLead = (data) => api.post("/leads", data).then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
